import TranslationService from '@/services/translation/TranslationService';
import ContextInfo from './settings/ContextInfo';

export default class SharedState {
  private _contextInfo: ContextInfo;
  private _translationService: TranslationService;
  private static channelKeyPrefix = 'corptube.channels.';
  
  constructor(contextInfo: ContextInfo) {
    this._contextInfo = contextInfo;
    this._translationService = new TranslationService(contextInfo.texts);
  }

  public get translationService() {
    return this._translationService;
  }

  public get contextInfo() {
    return this._contextInfo;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public static getInstance(context: any): SharedState {
    return context.root.$data.sharedState as SharedState;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public static getText(context: any, key: string): string {
    return this.getInstance(context).translationService.getValue(key);
  }

  public static getChannelText(context: any, keys: Array<string>): string {

    if(keys.length === 0) return '';
    for(const key of keys) {
      const lowerCaseKey = this.channelKeyPrefix + key.toLowerCase();
      const text = this.getText(context, lowerCaseKey);
      if(text !== lowerCaseKey) return text;
    }
    return keys[keys.length - 1];
  }
}